// extracted by mini-css-extract-plugin
export var fileExt = "_v9-8";
export var fileIcon = "_v9-6";
export var fileLink = "_v9-5";
export var fileName = "_v9-7";
export var image = "_v9-1";
export var imageError = "_v9-3";
export var imageErrorIcon = "_v9-4";
export var imageLink = "_v9-0";
export var imageLoaded = "_v9-2";